export default __webpack_public_path__ + "static/media/2129.4ecfbbf1.png";